import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { IoClose } from "react-icons/io5";
import bread from "../../img/bread.webp";

const images = [
  {
    src: "https://images.unsplash.com/photo-1585937421612-70a008356fbe?w=800&h=600&fit=crop",
    title: "Signature Curries",
    category: "food",
  },
  {
    src: "https://images.unsplash.com/photo-1563379091339-03b21ab4a4f8?w=800&h=600&fit=crop",
    title: "Aromatic Biryanis",
    category: "food",
  },
  {
    src: bread,
    title: "Professional Kitchen",
    category: "kitchen",
  },
  {
    src: "https://images.unsplash.com/photo-1567188040759-fb8a883dc6d8?w=800&h=600&fit=crop",
    title: "Tandoor Specials",
    category: "food",
  },
  {
    src: "https://images.unsplash.com/photo-1603894584373-5ac82b2ae398?w=800&h=600&fit=crop",
    title: "Chicken Curry",
    category: "food",
  },
  {
    src: "https://images.unsplash.com/photo-1601050690597-df0568f70950?w=800&h=600&fit=crop",
    title: "Traditional Thalis",
    category: "food",
  },
  {
    src: "https://images.unsplash.com/photo-1606787620819-8bdf0c44c293?w=800&h=600&fit=crop",
    title: "Fresh Ingredients",
    category: "kitchen",
  },
  {
    src: "https://images.unsplash.com/photo-1574484284002-952d92456975?w=800&h=600&fit=crop",
    title: "South Indian Delicacies",
    category: "food",
  },
  {
    src: "https://images.unsplash.com/photo-1565557623262-b51c2513a641?w=800&h=600&fit=crop",
    title: "Butter Chicken",
    category: "food",
  },
];

const Gallery = () => {
  const [selectedImage, setSelectedImage] = useState<number | null>(null);
  const [filter, setFilter] = useState<string>("all");

  const filteredImages =
    filter === "all" ? images : images.filter((img) => img.category === filter);

  return (
    <section className="w-full py-12 bg-white">
      <div className="w-full max-w-7xl mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-headingColor mb-4">
            Our Gallery
          </h2>
          <p className="text-textColor mb-8">
            Explore our delicious dishes, professional kitchen, and delivery
            service
          </p>

          <div className="flex justify-center gap-4 mb-8">
            {["all", "food", "kitchen", "delivery"].map((cat) => (
              <motion.button
                key={cat}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={() => setFilter(cat)}
                className={`px-6 py-2 rounded-full capitalize ${
                  filter === cat
                    ? "bg-gradient-to-r from-[#ac9430] to-[#227a32] text-white shadow-lg"
                    : "bg-lightGray text-textColor hover:bg-gray-200"
                }`}
              >
                {cat}
              </motion.button>
            ))}
          </div>
        </div>

        <motion.div
          layout
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4"
        >
          {filteredImages.map((image, index) => (
            <motion.div
              layout
              key={index}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.5 }}
              onClick={() => setSelectedImage(index)}
              className="relative cursor-pointer group overflow-hidden rounded-lg shadow-md hover:shadow-xl transition-shadow duration-300"
            >
              <motion.img
                whileHover={{ scale: 1.05 }}
                src={image.src}
                alt={image.title}
                className="w-full h-64 object-cover"
              />
              <div className="absolute inset-0 bg-black bg-opacity-40 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                <h3 className="text-white text-xl font-semibold text-center px-4">
                  {image.title}
                </h3>
              </div>
            </motion.div>
          ))}
        </motion.div>

        <AnimatePresence>
          {selectedImage !== null && (
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              onClick={() => setSelectedImage(null)}
              className="fixed inset-0 bg-black bg-opacity-90 z-50 flex items-center justify-center p-4"
            >
              <motion.div
                initial={{ scale: 0.5 }}
                animate={{ scale: 1 }}
                exit={{ scale: 0.5 }}
                className="relative max-w-4xl w-full"
                onClick={(e) => e.stopPropagation()}
              >
                <button
                  onClick={() => setSelectedImage(null)}
                  className="absolute -top-10 right-0 text-white text-3xl hover:text-[#ac9430] transition-colors"
                >
                  <IoClose />
                </button>
                <img
                  src={images[selectedImage].src}
                  alt={images[selectedImage].title}
                  className="w-full h-auto rounded-lg shadow-2xl"
                />
                <h3 className="text-white text-xl font-semibold mt-4 text-center">
                  {images[selectedImage].title}
                </h3>
              </motion.div>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </section>
  );
};

export default Gallery;
